<div
  class="header-wrapper"
  [class.show-background]="!isHeaderTransparent || showBackground"
>
  <div class="logo-wrapper" (click)="navigateToHome()">
    <img
      alt="beauty-booking"
      src="/assets/images/logos/beauty-booking-logo.png"
    />
    <h3
      [class.white-color]="isHeaderTransparent && !showBackground && isDarkMode"
    >
      Beauty Booking
    </h3>
  </div>

  <ng-container
    *ngIf="
      user || (breakpointService.isTabletViewObservable | async);
      else fullLabel
    "
  >
    <ng-container *ngIf="user; else normalMenuButton">
      <button
        [matBadgeOverlap]="true"
        [matBadgeHidden]="
          menuOpened || (user?.emailConfirmed && user?.phoneNrConfirmed)
        "
        matBadge="!"
        matBadgeColor="warn"
        mat-mini-fab
        color="primary"
        (click)="toggleSideNav.emit()"
      >
        <mat-icon
          [class.white-color]="
            isHeaderTransparent && !showBackground && isDarkMode
          "
          >{{ menuOpened ? 'close' : 'person' }}</mat-icon
        >
      </button>
    </ng-container>

    <ng-template #normalMenuButton>
      <button mat-icon-button (click)="toggleSideNav.emit()">
        <mat-icon
          [class.white-color]="
            isHeaderTransparent && !showBackground && isDarkMode
          "
          >{{ menuOpened ? 'close' : 'menu' }}</mat-icon
        >
      </button>
    </ng-template>
  </ng-container>

  <ng-template #fullLabel>
    <div fxLayout="row" fxLayoutAlign="start center">
      <ng-content></ng-content>
    </div>
  </ng-template>
</div>
